var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import FAIcon from "../FAIcon/FAIcon";
/**
 * Do not call in a component.  This makes a component; we should not be creating components on every render.
 */
export const makeButton = (btnType, iconClass, label, outline = false) => 
// eslint-disable-next-line react/display-name
React.forwardRef((_a, ref) => {
    var _b;
    var { className, size, type, link, isLoading, disabled, overrideColor, overrideLabel, overrideIconClass } = _a, otherProps = __rest(_a, ["className", "size", "type", "link", "isLoading", "disabled", "overrideColor", "overrideLabel", "overrideIconClass"]);
    let sizeString = "";
    if (size === "lg") {
        sizeString = " btn-lg";
    }
    else if (size === "sm") {
        sizeString = " btn-sm";
    }
    let btnClass = `btn-${outline ? "outline-" : ""}${overrideColor || btnType}`;
    // Don't do anything for link if this is an outline button
    if (link) {
        btnClass = "btn-link text-" + btnType;
    }
    const currentIconClass = (_b = overrideIconClass !== null && overrideIconClass !== void 0 ? overrideIconClass : iconClass) !== null && _b !== void 0 ? _b : "";
    return (
    // $FlowFixMe
    _jsxs("button", Object.assign({ className: `btn ${btnClass} ${className || ""} ${sizeString}`, 
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"button" | "submit" | "reset" | undefined'.
        type: type || "button", 
        // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean | undefined'.
        disabled: isLoading || disabled, ref: ref }, otherProps, { children: [_jsx(FAIcon, { icon: currentIconClass, className: currentIconClass || isLoading ? " mr-2" : "", isLoading: isLoading }), overrideLabel !== null && overrideLabel !== void 0 ? overrideLabel : label] })));
});
export const makeLink = (btnType, iconClass, label, outline = false) => (_a) => {
    var { className, href, size, link, isLoading, disabled, overrideColor, overrideLabel, overrideIconClass } = _a, otherProps = __rest(_a, ["className", "href", "size", "link", "isLoading", "disabled", "overrideColor", "overrideLabel", "overrideIconClass"]);
    let sizeString = "";
    if (size === "lg") {
        sizeString = " btn-lg";
    }
    else if (size === "sm") {
        sizeString = " btn-sm";
    }
    let btnClass = `btn-${outline ? "outline-" : ""}${overrideColor || btnType}`;
    // Don't do anything for link if this is an outline button
    if (link) {
        btnClass = "btn-link text-" + btnType;
    }
    const currentIconClass = overrideIconClass !== null && overrideIconClass !== void 0 ? overrideIconClass : iconClass;
    return (
    // $FlowFixMe
    _jsxs(Link, Object.assign({ className: `btn ${btnClass} ${className || ""} ${sizeString}`, 
        // @ts-expect-error - TS2322 - Type '{ children: (string | Element | null | undefined)[]; className: string; disabled: boolean | null | undefined; to: string; }' is not assignable to type 'IntrinsicAttributes & LinkProps<unknown> & RefAttributes<HTMLAnchorElement>'.
        disabled: isLoading || disabled, to: href }, otherProps, { children: [currentIconClass && (_jsx(FAIcon, { icon: currentIconClass, className: " mr-2", isLoading: isLoading })), overrideLabel !== null && overrideLabel !== void 0 ? overrideLabel : label] })));
};
/**
 *
 * @type {function(ButtonProps): *}
 */
export const SaveButton = makeButton("primary", null, "Save");
/**
 *
 * @type {function(ButtonProps): *}
 */
export const AddButton = makeButton("primary", "fal fa-plus", "Add");
/**
 *
 * @type {function(ButtonProps): *}
 */
export const DeleteButton = makeButton("danger", "fal fa-trash-alt", "Delete");
/**
 *
 * @type {function(ButtonProps): *}
 */
export const RemoveButton = makeButton("danger", "fal fa-ban", "Remove");
/**
 *
 * @type {function(ButtonProps): *}
 */
export const CancelButton = makeButton("secondary", null, "Cancel", true);
/**
 *
 * @type {function(ButtonProps): *}
 */
export const ModalCloseButton = makeButton("secondary", "fal fa-times", "Close", true);
/**
 *
 * @type {function(ButtonProps): *}
 */
export const EditButton = makeButton("primary", "fal fa-pencil-alt", "Edit");
/**
 *
 * @type {function(ButtonProps): *}
 */
export const SendButton = makeButton("primary", null, "Send");
/**
 *
 * @type {function(ButtonProps): *}
 */
export const AttachButton = makeButton("primary", "fal fa-paperclip", "Attach", true);
/**
 *
 * @type {function(ButtonProps): *}
 */
export const OkButton = makeButton("secondary", "fal fa-check", "Ok", true);
/**
 * To be used in modals where the action doesn't save an entity, but still applies some action.
 *
 *
 * @type {function(ButtonProps): *}
 */
export const ApplyButton = makeButton("primary", "fal fa-check", "Apply");
export const SearchButton = makeButton("primary", null, "Search");
export const DangerConfirmButton = makeButton("danger", null, "Yes");
const _ToggleButton = makeButton("light", "fa-toggle-off", `Off`);
export const ToggleButton = (_a) => {
    var { on, onLabel, offLabel } = _a, otherProps = __rest(_a, ["on", "onLabel", "offLabel"]);
    return (_jsx(_ToggleButton, Object.assign({ overrideIconClass: on ? "fas fa-toggle-on" : "fas fa-toggle-off", overrideLabel: on ? onLabel !== null && onLabel !== void 0 ? onLabel : "On" : offLabel !== null && offLabel !== void 0 ? offLabel : "Off" }, otherProps)));
};
const _BackLink = makeLink("link", "chevron-left", "Back");
export const BackLink = (_a) => {
    var { link } = _a, otherProps = __rest(_a, ["link"]);
    return (_jsx(_BackLink, Object.assign({}, otherProps, { link: link !== null && link !== void 0 ? link : true })));
};
